<template>
  <div>
    <h4>Saved Cards</h4>
    <div class=" col-md-9 p-1">
      <ContentLoader
        v-if="!responseObtained"
        :height="100"
      >
        <rect
          x="0"
          y="0"
          rx="3"
          ry="3"
          width="250"
          height="3"
        ></rect>
        <rect
          x="20"
          y="20"
          rx="3"
          ry="3"
          width="220"
          height="3"
        ></rect>
        <rect
          x="20"
          y="40"
          rx="3"
          ry="3"
          width="170"
          height="3"
        ></rect>
        <rect
          x="0"
          y="60"
          rx="3"
          ry="3"
          width="250"
          height="3"
        ></rect>
        <rect
          x="20"
          y="80"
          rx="3"
          ry="3"
          width="200"
          height="3"
        ></rect>
        <rect
          x="20"
          y="100"
          rx="3"
          ry="3"
          width="80"
          height="3"
        ></rect>
      </ContentLoader>
      <div v-if="responseObtained">
        <div class="saved-cards">
          <div
            v-for="(card,index) in cards"
            :key="index"
          >
            <div class="saved-card">
              <div class="form-check">
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    name="optradio"
                    v-model="selected"
                    :value="index"
                  >
                  <div class="card-no-cont">
                    <img
                      v-for="(cardImage, index) in cardImages.filter(cardImage => cardImage.name === card.brand)"
                      :src=cardImage.cardUrl
                      class="card-img"
                      :key="index"
                      :alt=cardImage.name
                    />
                    <span class="card-no">
                      XXXX {{card.last_four_digit}}
                    </span>
                  </div>
                  <span class="exp">
                    Exp: {{card.exp_month}}/{{card.exp_year}}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-danger"
        @click.prevent="deleteCard"
        v-if="responseObtained && this.cards.length > 0 &&
              !($route.path === '/checkout') && (selected !== '')"
      >
        Remove Selected Card
      </button>
      <div class="row">
        <div class="col-md-6">
          <button
            type="button"
            class="btn-sm btn-success"
            v-if="$route.path === '/checkout'&& this.cards.length > 0 && (selected !== '')  "
            @click.prevent="cardSelected"
          >
            Pay
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderApi } from '@/services/ApiServices/orderApi'
import { ContentLoader } from 'vue-content-loader'
import cardImageVisa from '@/assets/img/cards/1.png'
import cardImageMaster from '@/assets/img/cards/2.png'
import cardImageMaestro from '@/assets/img/cards/3.png'
import cardImagePaypal from '@/assets/img/cards/5.png'
import cardImageDiscover from '@/assets/img/cards/14.png'
import cardImageAmerican from '@/assets/img/cards/22.png'
import cardImageUnion from '@/assets/img/cards/24.png'
import cardImageDiner from '@/assets/img/cards/10.png'
import cardImageJCB from '@/assets/img/cards/16.png'

export default {
	name: 'stripe-card-list-template',
	components: {
		ContentLoader
	},
	data () {
		return {
			selected: '',
			index: null,
			cards: [],
			responseObtained: false,
			cardImages: [
				{
					name: 'Visa',
					cardUrl: cardImageVisa
				}, {
					name: 'MasterCard',
					cardUrl: cardImageMaster
				}, {
					name: 'Maestro',
					cardUrl: cardImageMaestro
				}, {
					name: 'Paypal',
					cardUrl: cardImagePaypal
				}, {
					name: 'Discover',
					cardUrl: cardImageDiscover
				}, {
					name: 'American Express',
					cardUrl: cardImageAmerican
				}, {
					name: 'UnionPay',
					cardUrl: cardImageUnion
				}, {
					name: 'JCB',
					cardUrl: cardImageJCB
				}, {
					name: 'Diners Club',
					cardUrl: cardImageDiner
				}
			]
		}
	},
	watch: {
		$route () {
			if (this.$route.path === '/checkout') {
				this.cardSelected()
			}
		}
	},
	beforeMount () {
		this.getAllSavedCards()
	},
	mounted () {
		this.$root.$on('newPaymentCardAdded', () => {
			this.responseObtained = false
		})
	},
	methods: {
		getAllSavedCards () {
			orderApi.getAllCards()
				.then((res) => {
					this.cards = res.data
					this.savedCards()
					this.responseObtained = true
				})
				.catch((e) => {

				})
		},
		deleteCard () {
			this.responseObtained = false

			const cardId = this.cards[this.selected].card_id

			orderApi.deletePaymentCard(cardId)
				.then(() => {
					this.selected = ''
					this.getAllSavedCards()
				})
				.catch((e) => {

				})
		},
		savedCards () {
			this.cards.forEach((card, index) => {
				card.text = `XXXX XXXX XXXX ${card.last_four_digit},
                     Exp: ${card.exp_month}/${card.exp_year}`
				card.value = index
			})
		},
		cardSelected () {
			this.$emit('cardSelected', this.cards[this.selected])
			this.$emit('paymentConfirmation')
		}
	}
}
</script>
